import { lazy } from "react";

import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import Navbar from "./components/Navbar";

import Footer from "./components/Footer";
import Landing from "./components/Landing";
import ImpactPage from "./components/ImpactPage";
import ContactUs from "./components/ContactUs";
import Terms from "./components/Terms";
import Privacy from "./components/Privacy";
import Returns from "./components/Returns";
import Grassroots from "./components/Grassroots.jsx";
import Smartschools from "./components/Smartschools.jsx";
import WhatsAppButton from "./components/WhatsAppButton.jsx";
import Blog from "./components/Blog.jsx";
import Pathyacharya from "./components/Pathyacharya.jsx";
import LiveTest from "./components/LiveTest.jsx";
import BoardPage from "./components/BoardPage.jsx";
const AboutUs = lazy(() => import("./components/AboutUs.jsx"));
const HybridPage = lazy(() => import("./components/HybridPage.jsx"));
const AssessmentPage = lazy(() => import("./components/AssessmentPage.jsx"));
const Careers = lazy(() => import("./components/Careers.jsx"));
const Kunji = lazy(() => import("./components/Kunji.jsx"));

function App() {
  return (
    <BrowserRouter>
      <div>
        <Navbar />
        <Routes>
          <Route path="/" element={<Navigate to="/pathyacharya" replace />} />
          <Route path="/home" element={<Landing />} />
          <Route path="/aboutus" element={<AboutUs />} />
          <Route
            path="/vernacular"
            element={<Navigate to="/pathyacharya" replace />}
          />
          <Route path="/kunji" element={<Kunji />} />
          <Route path="/hybrid" element={<HybridPage />} />
          <Route path="/assessment" element={<AssessmentPage />} />
          <Route path="/impact" element={<ImpactPage />} />
          <Route path="/contactus" element={<ContactUs />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/returns" element={<Returns />} />
          <Route path="/grassroots" element={<Grassroots />} />
          <Route path="/smart" element={<Smartschools />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/pathyacharya" element={<Pathyacharya />} />
          <Route path="/live-test" element={<LiveTest />} />
          <Route path="/:boardSlug" element={<BoardPage />} />
        </Routes>
        <WhatsAppButton />
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
